import { Eye } from "lucide-react";
import { useMeetingStore } from "../../store/meeting.store";

const ViewerList = () => {
  const viewers = useMeetingStore((s) => s.viewers);
  return (
    <div className="hidden lg:block w-36 flex-shrink-0">
      <div className="bg-white border-l border-gray-200 h-full overflow-y-auto  shadow-sm">
        <div className="p-2 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100">
          <h3 className="font-bold text-gray-800 flex items-center text-lg">
            <Eye size={20} className="mr-3 text-gray-600" />
            Viewers ({viewers.length})
          </h3>
        </div>
        <div className="space-y-2 py-2 px-1 h-[calc(100vh-146px)]">
          {viewers?.map((viewer: any, index: number) => (
            <div
              key={index}
              className="flex items-center space-x-2  hover:bg-gray-50 rounded-lg transition-colors duration-200 border border-transparent hover:border-gray-200"
            >
              <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center shadow-sm text-white font-bold">
                {/* <Users size={16} className="text-white" /> */}
                {viewer.name?.slice(0, 1).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-gray-900 truncate">
                  {viewer.name}
                </div>
                <div className="text-xs text-gray-500 font-medium">
                  {viewer.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ViewerList;
